<template>
  <div class="common-wrapper">
    <GoodsList
      :isRequestingPackageList="isLoading"
      :goodList="list"
      :checkList="checkList"
      :moneyUnit="moneyUnit"
      :activityData="activityData"
      @goodItemClick="$emit('goodItemClick', $event)"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import GoodsList from '@/components/common/Goods/index.vue'

export default {
  name: 'ShopRenderer',
  components: { GoodsList },
  computed: {
    ...mapState('gift/shop', ['list', 'checkList', 'moneyUnit', 'isLoading', 'activityData']),
  },
}
</script>

<style lang="less" scoped></style>
